import React, { useContext, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
//Styles
import {
  Container,
  Body,
  Header,
  LabelCase,
  TypeCase,
  TypeContainer,
  TypePerson,
  TypePersonContainer,
  Button,
  CurrentState,
  CurrentStep,
  Fotter,
  Instruction,
  Loading,
  TextArea,
  UploadContainer,
  Description,
  Label,
  Detail,
  FileContainer,
  File,
  FormContainer,
  FormGroup,
  Upload,
  TableTitle,
  PillCategory,
  ServiceSubtitle,
  DeleteIcon,
  PlusIcon,
  ContainerPersons,
} from "./style";
import { Error, TextField } from "@pages/NewPQRS/Step1/style";
//Types
import { TypesPage } from "@context/types/page";
import { AppContext } from "@context";
import { TypesPersonality } from "@context/types/legalpersonality";
import { IFormDescribe } from "./interface";
import { IOptions } from "@components/form/Select/interface";
import { createIssu } from "@api/services/issues";
import { TypesAnonymous } from "@context/types/anonymous";
import { TypesData } from "@context/types/data";
import { TypesPatient } from "@context/types/patient";
//Components
import CompleteIssue from "@components/modal/CompleteIssue";
import { TypesLoading } from "@context/types/loading";
import { toast } from "react-toastify";
import { valueToNull } from "@utils";

const Step3 = () => {
  const { state, dispatch } = useContext(AppContext);
  const { islegal, describe, data, patient, anonymous } = state;
  const [success, setSuccess] = useState(false);
  const [serial, setSerial] = useState("");
  const methods = useForm<IFormDescribe>({ defaultValues: describe });
  const { register, handleSubmit, errors, watch } = methods;
  const [persons, setPersons] = useState<string[]>([]);
  const [person, setperson] = useState<string>("");
  const history = useHistory();
  const location = useLocation();
  const currentWatch = watch("evidence");
  const inputPerson = useRef();
  const closeMadal = () => {
    dispatch({ type: TypesPersonality.Natural });
    dispatch({ type: TypesPage.Reset });
    dispatch({ type: TypesAnonymous.NotAnonymous });
    dispatch({ type: TypesData.ResetData });
    dispatch({ type: TypesPatient.Reset });
    setSuccess(false);
    history.push("/");
  };
  const goBack = () => {
    dispatch({ type: TypesPage.Previous });
  };
  const selectLegal = () => {
    dispatch({ type: TypesPersonality.Legal });
    dispatch({ type: TypesPage.Reset });
    dispatch({ type: TypesAnonymous.NotAnonymous });
  };
  const selectNatural = () => {
    dispatch({ type: TypesPersonality.Natural });
    dispatch({ type: TypesPage.Reset });
  };
  const onSave = async (values: IFormDescribe) => {
    const typeIssue = (location.state as { type: number }).type;
    /* let entityType = patient.legal?.entityType ?? "";
    if (entityType === "et" || entityType === "os" || entityType === "ss") {
      entityType = "entity";
    }
    let entity = patient.legal?.entity;
    //@ts-ignore
    if (!entity) {
      entity = "Superintendencia Nacional de Salud";
    }
    if (entity.value) {
      entity = patient.legal?.entity.value;
    } */
    //Contact if legal or natural.
    let contact;
    if (islegal) {
      contact = {
        entityId: valueToNull<string>(patient.legal?.entity?.value),
        country: valueToNull<string>((patient.country as IOptions)?.label),
        state: valueToNull<string>((patient.state as IOptions)?.label),
        city: valueToNull<string>((patient.city as IOptions)?.label),
        email: valueToNull<string>(patient.email),
        phone: patient.phone ? `+57${patient.phone}` : null,
      };
    }

    if (!islegal) {
      contact = {
        name: valueToNull<string>(patient.natural?.name),
        lastname: valueToNull<string>(patient.natural?.lastName),
        relation_type: valueToNull<number>(
          Number(patient.natural?.relationshipType)
        ),
        relation: valueToNull<string>(patient.natural?.relationship),
        relationship: valueToNull<number>(
          (patient.natural?.bond as IOptions)?.value as number
        ),
        docType: valueToNull<number>(
          (patient.natural?.docType as IOptions)?.value as number
        ),
        document: valueToNull<string>(patient.natural?.documemt),
        country: valueToNull<string>((patient.country as IOptions)?.label),
        state: valueToNull<string>((patient.state as IOptions)?.label),
        city: valueToNull<string>((patient.city as IOptions)?.label),
        email: valueToNull<string>(patient.email),
        phone: patient.phone ? `+57${patient.phone}` : null,
      };
    }
    if (anonymous) {
      contact = {
        email: valueToNull<string>(patient.email),
        phone: patient.phone ? `+57${patient.phone}` : null,
      };
    }
    let address;
    if (patient.streetName && patient.address && patient.neighborhood) {
      address = `${patient.streetName.value} ${patient.address} ${
        patient.neighborhood
      } ${patient.addressDetail ?? ""}`;
    }
    const issue = {
      description: valueToNull<string>(values.detail),
      response: (patient.means as IOptions)?.value as number,
      type: typeIssue,
      patient: {
        name: valueToNull<string>(data.name),
        lastname: valueToNull<string>(data.lastname),
        docType: valueToNull<number>(
          (data.docType as IOptions)?.value as number
        ),
        document: valueToNull<string>(data.document),
        birthday: valueToNull<string>(data.birthday),
        minorityId: valueToNull<number>(
          (data.minorityId as IOptions)?.value as number
        ),
        entityId: valueToNull<number>(
          (data.epsId as IOptions)?.value as number
        ),
      },
      contact: {
        ...contact,
        address,
      },
      congrats: persons.length ? persons : undefined,
      /* areas: data.areas.map((area) => ({
        id: Number(area),
      })), */
    };
    try {
      dispatch({ type: TypesLoading.Loading });
      //@ts-ignore
      const serial = await createIssu(issue, values.evidence[0]);
      setSuccess(true);
      setSerial(serial);
      dispatch({ type: TypesLoading.NotLoading });
    } catch (e) {
      dispatch({ type: TypesLoading.NotLoading });
      toast.error("No se puede generar la PQRS", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <Container onSubmit={handleSubmit(onSave)}>
      <Header>
        <TypeContainer>
          <LabelCase>Radicar Nuevo Caso</LabelCase>
          <TypeCase color={location.state.color}>
            {location.state.title}
          </TypeCase>
        </TypeContainer>
        <TypePersonContainer>
          <TypePerson onClick={selectNatural} selected={!islegal}>
            Persona natural
          </TypePerson>
          <TypePerson onClick={selectLegal} selected={islegal}>
            Persona jurídica
          </TypePerson>
        </TypePersonContainer>
      </Header>
      <Body>
        <FormContainer>
          <FormGroup>
            <TextArea
              name={"detail"}
              ref={register({ required: true })}
              placeholder={"Describa su caso..."}
            ></TextArea>
            {errors.detail?.type === "required" && <Error>Es requerido</Error>}
          </FormGroup>
          <UploadContainer>
            <Description>
              <Label>
                {currentWatch?.length ? "Nombre Del Archivo:" : "Subir archivo"}
              </Label>
              <Detail>
                {currentWatch?.length
                  ? currentWatch[0].name
                  : `Si desea añadir una archivo a su respuesta`}
              </Detail>
            </Description>
            <FileContainer>
              <File>
                <Upload />
                <input
                  name={"evidence"}
                  ref={register({})}
                  type={"file"}
                  hidden
                />
              </File>
            </FileContainer>
          </UploadContainer>
        </FormContainer>
        {(location.state as { type: number }).type === 4 && (
          <ContainerPersons>
            <TableTitle>¿A Quien Deseas Felicitar?</TableTitle>
            {persons.map((person, idx) => (
              <PillCategory key={idx}>
                <ServiceSubtitle>{person}</ServiceSubtitle>
                <DeleteIcon
                  onClick={() => {
                    const list = persons.filter((person, i) => idx !== i);
                    setPersons([...list]);
                  }}
                />
              </PillCategory>
            ))}
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                ref={inputPerson}
                onChange={(e) => {
                  setperson(e.currentTarget.value);
                }}
              />
              <PlusIcon
                onClick={() => {
                  if (person !== "") {
                    setPersons([...persons, person]);
                    inputPerson.current.value = "";
                    setperson("");
                  }
                }}
              />
            </div>
          </ContainerPersons>
        )}
        <Fotter>
          <Instruction>
            Los campos marcados con "*" son obligatorios según la circular 008
            de 2018 de la Superintendencia Nacional de Salud.
          </Instruction>
          <CurrentStep>Paso 3 de 3</CurrentStep>
          <Loading>
            <CurrentState />
          </Loading>
          <div>
            <Button onClick={goBack} type={"button"}>
              Anterior
            </Button>
            <Button type={"submit"}>Siguiente</Button>
          </div>
        </Fotter>
      </Body>
      <CompleteIssue isopen={success} onClose={closeMadal} serial={serial} />
    </Container>
  );
};

export default Step3;
